import { z, ZodType } from 'zod';
import { entityWithNameSchema } from './entity-with-name';
import { Shift } from './shift';

export type ShiftPersonal = Shift & {
	deposits: number;
	withdrawals: number;
	income: number;
};

export const shiftPersonalSchema: ZodType<ShiftPersonal> = z.object({
	id: z.string(),
	openingBalance: z.number(),
	closingBalance: z.number(),
	currency: z.string(),
	isActive: z.boolean(),
	owner: entityWithNameSchema,
	deposits: z.number(),
	withdrawals: z.number(),
	income: z.number(),
});
